<ng-template #noresults>
   <div class="no-results">No Results Found</div>
</ng-template>

<ng-template #loading><lib-loading></lib-loading></ng-template>

<ng-container *ngIf="report.report as r; else loading">
   <div class="flex report-container">
      <header emphasis class="common-fg1">{{r.name ? r.name : 'Preview'}}</header>
      <div *ngIf="report.response$ | async">
         <ng-container *ngIf="!breakpoints.small">
            <button [disabled]="report.pagination.loading" class="refresh-button" mat-stroked-button color="primary" *ngIf="r.id" (click)="this.loadReport(true)">
               <mat-icon>refresh</mat-icon> REFRESH
            </button>
            <button mat-stroked-button color="primary" *ngIf="r.id && r.owned" routerLink="/report/edit/{{r.id}}">
               <mat-icon>edit</mat-icon> EDIT
            </button>
            <button mat-stroked-button color="primary" *ngIf="r.id && !r.owned" routerLink="/report/copy/{{r.id}}">
               <mat-icon>filter_none</mat-icon> COPY
            </button>
         </ng-container>
         <button mat-icon-button color="primary" [matMenuTriggerFor]="menu" *ngIf="dataSource.data?.length || breakpoints.small">
            <mat-icon>more_vert</mat-icon>
         </button>
      </div>
   </div>

   <mat-menu #menu="matMenu" class="float-menu" xPosition="before">
      <ng-container *ngIf="breakpoints.small">
         <button [disabled]="report.pagination.loading" class="refresh-button" mat-menu-item *ngIf="r.id" (click)="this.loadReport(true)">
            <mat-icon>refresh</mat-icon> REFRESH
         </button>
         <button mat-menu-item *ngIf="r.id && r.owned" routerLink="/report/edit/{{r.id}}">
            <mat-icon>edit</mat-icon> EDIT
         </button>
         <button mat-menu-item *ngIf="r.id && !r.owned" routerLink="/report/copy/{{r.id}}">
            <mat-icon>filter_none</mat-icon> COPY
         </button>
      </ng-container>

      <ng-container *ngIf="dataSource.data?.length">
         <button mat-menu-item (click)="downloadCSV( dataSource.filteredData )" matTooltip="Make sure popups are allowed">
            <mat-icon>get_app</mat-icon> EXPORT AS CSV
         </button>

         <button mat-menu-item (click)="downloadJSON( dataSource.filteredData )">
            <mat-icon>get_app</mat-icon> EXPORT AS JSON
         </button>

         <ng-container *ngIf="r.id == 27">
            <button mat-menu-item (click)="downloadTemplate({ type: 'template', name: activeAccountNumber + '_ShipmentManifest_' + getDate() })">
               <mat-icon>get_app</mat-icon> SHIPMENT MANIFEST
            </button>
         </ng-container>

         <ng-container *ngIf="report.response.actions as actions">
            <button mat-menu-item *ngIf="actions.length == 1" (click)="downloadTemplate( actions[0] )" [matTooltip]="'Export as ' + actions[0].name">
               <mat-icon>get_app</mat-icon> {{actions[0].name}}
            </button>

            <button mat-menu-item [matMenuTriggerFor]="exportMenu" *ngIf="actions.length > 1">
               <mat-icon>get_app</mat-icon> Export Template
            </button>

            <mat-menu #exportMenu="matMenu" class="float-menu" xPosition="before">
               <button mat-menu-item *ngFor="let action of actions" (click)="downloadTemplate( action )"> {{action.name | uppercase}}
               </button>
            </mat-menu>
         </ng-container>
      </ng-container>
   </mat-menu>
   <mat-divider></mat-divider>
</ng-container>

<lib-http-pagination></lib-http-pagination>

<ng-container *ngIf="report.response$ | async">
   <ng-container *ngIf="dataSource.data?.length else noresults">
      <div *ngIf="dataSource.filter" class="filter-title">
         Results are filtered - {{dataSource.filteredData.length}} out of {{dataSource.data.length}} shown
      </div>

      <div *ngIf="report.responseColumns as columns" class="common-ofauto common-relative table-container">
         <mat-table #table_header matSort [dataSource]="dataSource" class="sticky rotate-cdk-table" [style.width.px]="report.total_column_width$() | async" class="common-minw100perc">
            <ng-container *ngFor="let column of columns;" [matColumnDef]="column">
               <mat-header-cell *matHeaderCellDef mat-sort-header
                  class="common-pointer"
                  (click)="setSortDir( column )"
                  (mouseenter)="hovered = column"
                  (mouseleave)="hovered = null"
                  [style.flex-basis.px]="report.column_width$( column ) | async"
               >
                  {{report.header( column )}} &nbsp;

                  <mat-icon
                     class="flip common-op04"
                     [class.active]="sort?.active === column"
                     [class.flip]="sort?.active === column && sort?.direction === 'asc'"
                     [style.visibility]="((hovered === column || sort?.active === column) && sort?.direction) || 
                     (hovered === column && sort?.active !== column ) ? 'initial' : 'hidden'">
                     sort
                  </mat-icon>

               </mat-header-cell>
               <mat-cell class="report-cell common-pointer" [style.flex-basis.px]="report.column_width$( column ) | async" *matCellDef="let element" (click)="viewData( element,column )">
                  <div *ngIf="column != 'hawb'">{{element[column]}}</div>
                  <div *ngIf="column == 'hawb'"><a>{{element[column]}}</a></div>
               </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="columns; sticky: true" class="mat-elevation-z1 common-flex"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columns"></mat-row>
         </mat-table>
      </div>

      <mat-paginator #paginator
         showFirstLastButtons
         [pageSize]="pageSize"
         [pageSizeOptions]="[5, 10, 25, 100]"
         (page)="pageSize = $event.pageSize; pageIndex = $event.pageIndex;">
      </mat-paginator>
   </ng-container>
</ng-container>
